(ns hai.datetime)

;; js/undefined defaults to the user's system locale
(def system-locale js/undefined)

(def ^:private time-formatter
  (js/Intl.DateTimeFormat. system-locale #js {:hour "numeric" :minute "2-digit"}))

(def ^:private date-formatter
  (js/Intl.DateTimeFormat. system-locale #js {:weekday "long" :month "long" :day "numeric" :year "numeric"}))

(defn format-time [d]
  (.format time-formatter d))

(defn format-date [d]
  (.format date-formatter d))

(defn format-hour-recognizable [h]
  (let [[hour literal1 minute literal2 day-period] (->> (doto (js/Date.) (.setHours h 0 0 0))
                                                        (.formatToParts time-formatter)
                                                        (map #(some-> % .-value)))]
    ^{:key h} [:span hour (if day-period
                            [:span literal2 day-period]
                            [:small literal1 minute])]))
